import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { JournalReviewItem } from 'donor-elf-web/controllers/funds/fund/journals/journal/review-items';
import { queryWithPages } from 'donor-elf-web/lib/store-utils';
import ContactDuplicateModel from 'donor-elf-web/models/contact-duplicate';
import ReviewItemModel from 'donor-elf-web/models/review-item';

export interface JournalReviewItemRouteModel {
  items: JournalReviewItem[];
}
export default class JournalsIndexRoute extends Route {
  @service declare fundsService: any;
  @service declare journalService: any;
  @service declare navbarSettings: any;
  @service declare store: Store;

  async model(): Promise<JournalReviewItemRouteModel> {
    await this.fundsService.confirmValidFundToken();
    await this.journalService.load();
    // @ts-expect-error
    let journalId = this.paramsFor('funds.fund.journals.journal').journalId;
    let journalInfo = this.journalService.journalInfoById(journalId);
    this.navbarSettings.title = `${journalInfo.journal.label} Journal`;

    let contactDuplicates = await queryWithPages<ContactDuplicateModel>({
      store: this.store,
      modelName: 'contact-duplicate',
      queryOptions: { filter: { journal_id: journalId } },
      pageSize: 50,
    });
    let reviewItems = await queryWithPages<ReviewItemModel>({
      store: this.store,
      modelName: 'review-item',
      queryOptions: { filter: { journal_id: journalId, answered: false } },
      pageSize: 50,
    });

    return {
      items: [
        ...contactDuplicates.map(
          (x) => new JournalReviewItem({ contactDuplicate: x }),
        ),
        ...reviewItems.map((x) => new JournalReviewItem({ reviewItem: x })),
      ],
    };
  }
}
